import useLastAcknowledgedActivityKey from './druid/providers/ActivityAcknowledgement/useLastAcknowledgedActivityKey';

export default useLastAcknowledgedActivityKey;
